import api from '@/api'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'

export default {
	mixins: [adMixin, adTrackingMixin],
	data() {
		return {
			// 直接放图片url
			imgs: [],
			downloadImgs: [],
			isFin: false,
		}
	},
	//一跳转结果页就开始请求
	async mounted() {
		console.log(`-------------------${this.$options.name} mounted`)
		await this.initAdSystem()
		// 确保在广告系统初始化后再初始化跟踪
		this.$nextTick(() => {
			this.initAdTracking()
		})

		console.log('🚀🚀🚀 this.$route.params: ', this.$route.params)
		if (!this.$route.params.text) {
			this.go('/generate')
		}
		// 创建绘画任务
		const res = await api.requestPaint({
			prompt: this.$route.params.text,
		})
		let taskId
		console.log('绘画请求任务id ', res?.data)
		// 如果没有金币了,跳转回去
		if (res.code == 1001) {
			this.go('/generate')
			this.$message({
				message: 'Sorry! Your gold coins is insufficient!',
				type: 'error',
				duration: 4000,
			})
			return
		}

		if (res?.success) {
			taskId = res.data
			this.$store.state.taskId = taskId
		} else {
			// 绘画请求失败
			this.go('/generate')
			this.$message({
				message: 'Image generation failed, please try again',
				type: 'error',
				duration: 3000,
			})
			return
		}
		// 轮训后端接口任务好没
		const syncPromise = () => {
			return api.checkTask({
				taskId,
				time: Date.now(),
			})
		}
		const timeoutPromise = (delayTime) => {
			return new Promise((resolve) => {
				window.timeId = setTimeout(resolve, delayTime)
			})
		}
		const pollFetch = async () => {
			while (true) {
				// 如果页面跳转了要清除当前的任务id，跳出轮换
				if (this.$store.state.taskId < 0) {
					break
				}
				const pollingTime = 3 * 1000
				try {
					const res = await syncPromise()
					// 如果轮训报错
					if (res.code == 500) {
						this.go('/generate')
						this.$message({
							message: 'Image generation failed, please try again',
							type: 'error',
							duration: 4000,
						})
						return
					}
					console.log('轮训结果:', res.data)
					if (res?.data.type === 3) {
						this.imgs.push(res?.data.img1_url)
						this.imgs.push(res?.data.img2_url)
						this.imgs.push(res?.data.img3_url)
						this.imgs.push(res?.data.img4_url)
						this.isFin = true
						await this.getUserInfo()
						break
					}
					if (res?.data.type === 4) {
						this.go('/generate')
						this.$message({
							message: 'Image generation failed, please try again',
							type: 'error',
							duration: 3000,
						})
						return
					}
					await timeoutPromise(pollingTime)
				} catch (e) {
					await timeoutPromise(pollingTime)
				}
			}
		}
		pollFetch()
	},
	async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
	methods: {
		downloadPics() {
			let i = 0
			let _this = this
			this.$store.state.loading = true
			const downloadPicture = (imgSrc, name) => {
				const image = new Image()
				// 解决跨域 Canvas 污染问题
				image.src = imgSrc + '?tamp=' + new Date().valueOf()
				image.crossOrigin = 'Anonymous'
				image.onload = () => {
					const canvas = document.createElement('canvas')
					canvas.width = image.width
					canvas.height = image.height
					const context = canvas.getContext('2d')
					context.drawImage(image, 0, 0, image.width, image.height)
					canvas.toBlob((blob) => {
						const url = URL.createObjectURL(blob)
						const a = document.createElement('a')
						a.download = name || 'photo'
						a.href = url
						a.click()
						i++
						console.log(imgSrc, 'ok')
						if (i === 4) {
							_this.$store.state.loading = false
							_this.$message({
								message: 'download success!',
								type: 'success',
								duration: 3000,
							})
						}
						a.remove()
						URL.revokeObjectURL(url)
					})
				}
			}

			this.imgs.forEach((e, i) => {
				downloadPicture(e, i + '.png')
			})
		},
	},
	metaInfo() {
		const description = "View and download your AI-generated images. Experience the magic of AI creativity."
		return {
			title: "Your AI Image Results",
			meta: [
				{
					name: 'description',
					content: description,
				},
			],
		}
	},
}
